<h3 class="font-extrabold mb-6">Order Setback: {{ data.name }}</h3>

<form [formGroup]="setbackForm" class="overflow-x-hidden">
	<div class="grid">
		<app-date-picker
			[label]="'Start Date'"
			[placeholder]="'Start Date'"
			[required]="true"
			formControlName="startDate">
		</app-date-picker>

		<app-time-input
			[label]="'Start Time'"
			[placeholder]="'Type Start Time'"
			[required]="true"
			[formControl]="setbackForm.get('startTime')"
			class="mt-2">
		</app-time-input>

		<app-time-input 
			*ngFor="let job of setbackForm.get('laborOrderJobs')['controls']"
			[label]="'Start Time for ' + job.get('name').value"
			[placeholder]="'Type Start Time for ' + job.get('name').value"
			[required]="true"
			[formControl]="job.get('startTime')"
			class="mt-2">
		</app-time-input>

		<label class="base-input-label w-full mt-2">
			Comments*
			<textarea
				formControlName="comments"
				cols="60"
				rows="3"
				placeholder="Type Comments"
				class="border-2 rounded mt-1 text-gray-600 p-4">
			</textarea>
		</label>
	</div>
	<app-dialog-footer 
		[valid]="setbackForm.valid"
		[isSaving]="loading"
		[submitActionName]="'Confirm'"
		(cancelAction)="close()"
		(submitAction)="confirm()">
	</app-dialog-footer>
</form>